import { render } from "./UeStudentsEditView.vue?vue&type=template&id=f0189e20&scoped=true"
import script from "./UeStudentsEditView.vue?vue&type=script&lang=js"
export * from "./UeStudentsEditView.vue?vue&type=script&lang=js"

import "./UeStudentsEditView.vue?vue&type=style&index=0&id=f0189e20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0189e20"]])

export default __exports__